import CfSectionShell, { CfSectionShellFields } from '../cf-section-shell'
import { Accordion, Stack } from '~/components-v2'
import ReactMarkdown from 'react-markdown'

interface CFListItemProps {
  fields: {
    name: string
    description: string
  }
}

export interface FaqsFields {
  headline?: string
  groupHeadline?: string
  faqs: CFListItemProps[]
}

interface CfFaqsSectionProps {
  fields: CfSectionShellFields & FaqsFields
}

export function CfFaqsSection({ fields }: CfFaqsSectionProps) {
  const { id, paddingTop, paddingBottom, showBottomBorder, theme } = fields
  const { headline, faqs, groupHeadline } = fields

  return (
    <CfSectionShell
      id={id}
      paddingTop={paddingTop}
      paddingBottom={paddingBottom}
      showBottomBorder={showBottomBorder}
      theme={theme}
    >
      <div className="cf-faqs">
        {headline && (
          <Stack className="centered-section-title" as="hgroup">
            <h2>{headline}</h2>
          </Stack>
        )}

        {faqs && (
          <div className="faqs">
            {groupHeadline && (
              <h3 className="faqs-group-headline">{groupHeadline}</h3>
            )}

            {faqs
              .filter((faq) => Boolean(faq?.fields))
              .map((faq, index) => {
                const name = faq.fields?.name ?? ''
                const description = faq.fields?.description ?? ''
                return (
                  <Accordion title={name} key={`faq-${index}`} open>
                    <ReactMarkdown>{description}</ReactMarkdown>
                  </Accordion>
                )
              })}
          </div>
        )}
      </div>
    </CfSectionShell>
  )
}
